/**
 * meta.needLogin  是否需要登录权限
 *
 * meta.crumbs  面包屑导航
 * meta.crumbs[n].link  可以是vue router，也可以是页面绝对路径
 *
 * meta.title  页面的title
 */
const title = '智慧冷库'
let routers = [
  {
    path: '/login',
    name: 'login',
    component: resolve => require(['@/components/user/login.vue'], resolve),
    meta: { title: `${title}-登录`, needLogin: false }
  },
  {
    path: '/account',
    name: 'account',
    component: resolve => require(['@/components/user/account.vue'], resolve),
    meta: {
      title: `${title}-账户`,
      needLogin: false
    }
  },
  {
    path: '/',
    component: resolve => require(['@/layout/index.vue'], resolve),
    children: [
      {
        path: '/',
        name: 'HomePage',
        component: resolve => require(['@/components/homePage/index.vue'], resolve),
        meta: {
          title: `${title}-主页`,
          needLogin: true
        }
      },
      {
        path: '/center',
        name: 'Center',
        component: resolve => require(['@/components/user/center.vue'], resolve),
        meta: {
          title: `${title}-个人中心`,
          needLogin: true
        }
      },
      {
        path: '/Monitor',
        name: 'Monitor',
        component: resolve => require(['@/components/monitor/index.vue'], resolve),
        meta: {
          title: `${title}-实时监控`,
          needLogin: true
        }
      },
      {
        path: '/ConfigurationMonitor',
        name: 'ConfigurationMonitor',
        component: resolve => require(['@/components/monitor/configurationMonitor/index.vue'], resolve),
        meta: {
          title: `${title}-组态监控`,
          needLogin: true
        }
      },
      {
        path: '/VideoMonitor',
        name: 'VideoMonitor',
        component: resolve => require(['@/components/monitor/videoMonitor/index.vue'], resolve),
        meta: {
          title: `${title}-视频监控`,
          needLogin: true
        }
      },
      {
        path: '/dataMonitor',
        name: 'DataMonitor',
        component: resolve => require(['@/components/monitor/dataMonitor/index.vue'], resolve),
        meta: {
          title: `${title}-数据监控`,
          needLogin: true
        }
      },
      {
        path: '/RealTimeOperation',
        name: 'RealTimeOperation',
        component: resolve => require(['@/components/realTimeOperation/index.vue'], resolve),
        meta: {
          title: `${title}-实时操控`,
          needLogin: true
        }
      },
      {
        path: '/Query',
        name: 'Query',
        component: resolve => require(['@/components/query/index.vue'], resolve),
        meta: {
          title: `${title}-综合查询`,
          needLogin: true
        }
      },
      {
        path: '/CoolRoomQuery',
        name: 'CoolRoomQuery',
        component: resolve => require(['@/components/query/coolRoomQuery/index.vue'], resolve),
        meta: {
          title: `${title}-冷间查询`,
          needLogin: true
        }
      },
      {
        path: '/EquipmentQuery',
        name: 'EquipmentQuery',
        component: resolve => require(['@/components/query/equipmentQuery/index.vue'], resolve),
        meta: {
          title: `${title}-设备查询`,
          needLogin: true
        }
      },
      {
        path: '/ExportData',
        name: 'ExportData',
        component: resolve => require(['@/components/exportData/index.vue'], resolve),
        meta: {
          title: `${title}-导出数据`,
          needLogin: true
        }
      },
      {
        path: '/PermissionsAllocation',
        name: 'PermissionsAllocation',
        component: resolve => require(['@/components/permissionsAllocation/index.vue'], resolve),
        meta: {
          title: `${title}-权限分配`,
          needLogin: true
        }
      },
      {
        path: '/Log',
        name: 'Log',
        component: resolve => require(['@/components/log/index.vue'], resolve),
        meta: {
          title: `${title}-操作日志`,
          needLogin: true
        }
      },
      {
        path: '/FieldLog',
        name: 'FieldLog',
        component: resolve => require(['@/components/FieldLog/index.vue'], resolve),
        meta: {
          title: `${title}-现场日志`,
          needLogin: true
        }
      },
      {
        path: '/Alarm',
        name: 'Alarm',
        component: resolve => require(['@/components/alarm/index.vue'], resolve),
        meta: {
          title: `${title}-报警统计`,
          needLogin: true
        }
      },
      {
        path: '/FaultStatistics',
        name: 'FaultStatistics',
        component: resolve => require(['@/components/alarm/faultStatistics/index.vue'], resolve),
        meta: {
          title: `${title}-故障统计`,
          needLogin: true
        }
      },
      {
        path: '/NoticeHistory',
        name: 'NoticeHistory',
        component: resolve => require(['@/components/alarm/noticeHistory/index.vue'], resolve),
        meta: {
          title: `${title}-通知历史`,
          needLogin: true
        }
      },
      {
        path: '/EnergyMonitoring',
        name: 'EnergyMonitoring',
        component: resolve => require(['@/components/energyMonitoring/index.vue'], resolve),
        meta: {
          title: `${title}-能耗监控`,
          needLogin: false     //false  true
        }
      },
      {
        path: '/dailyQuery',
        name: 'dailyQuery',
        component: resolve => require(['@/components/TariffEnquiry/dailyQuery/index.vue'], resolve),
        meta: {
          title: `${title}-天级数据查询`,
          needLogin: true 
        }
      },
      {
        path: '/hourQuery',
        name: 'hourQuery',
        component: resolve => require(['@/components/TariffEnquiry/hourQuery/index.vue'], resolve),
        meta: {
          title: `${title}-小时级级数据查询`,
          needLogin: true 
        }
      },
      {
        path: '/StepSetting',
        name: 'StepSetting',
        component: resolve => require(['@/components/TariffEnquiry/StepSetting/index.vue'], resolve),
        meta: {
          title: `${title}-电价设置`,
          needLogin: true
        }
      }
    ]
  },
  {
    path: '*',
    name: 'error',
    component: resolve => require(['@/components/404.vue'], resolve),
    meta: { title: '您访问的页面找不到', needLogin: false }
  }
]

export default routers



// WEBPACK FOOTER //
// ./src/router/routers.js